import { FC } from 'react';
import { ChevronLeft, ChevronRight, CalendarPlus } from 'lucide-react';
import { formatDateRange, getUserTimezone } from '../../lib/helpers';
import { NavigationButton } from './NavigationButton';
import { CalendarLegendItem } from './CalendarLegendItem';
import { SLOT_COLORS } from '../../lib/constants';

interface CalendarHeaderProps {
  weekStart: Date;
  weekEnd: Date;
  onPreviousWeek: () => void;
  onNextWeek: () => void;
  onToday: () => void;
  onAddRange: () => void;
}

export const CalendarHeader: FC<CalendarHeaderProps> = ({
  weekStart,
  weekEnd,
  onPreviousWeek,
  onNextWeek,
  onToday,
  onAddRange,
}) => {
  return (
    <div className="flex flex-wrap items-center justify-between gap-4">
      <div className="flex flex-col gap-4">
        <h3 className="[font-size:var(--fs-h6)] font-semibold text-(--neutral-black-NB900)! m-0!">
          {formatDateRange(weekStart, weekEnd)}
        </h3>
        <p className="[font-size:var(--fs-l4)] text-(--neutral-black-NB900) m-0!">
          <span className="font-semibold">Timezone:</span> {getUserTimezone()}
        </p>
        <div className="flex items-center gap-3 text-xs">
          <CalendarLegendItem label="Available" colorClass={SLOT_COLORS.available} />
          <CalendarLegendItem label="Pending" colorClass={SLOT_COLORS.pending} />
          <CalendarLegendItem label="Booked" colorClass={SLOT_COLORS.booked} />
          <CalendarLegendItem label="Selecting" colorClass={SLOT_COLORS.selected} />
        </div>
      </div>
      <div className="flex items-center gap-2">
        <button
          onClick={onAddRange}
          className="px-3 py-1.5 [font-size:var(--fs-l4)] font-medium text-(--primary-O900)! bg-(--primary-O200) hover:bg-(--primary-O300) rounded-full! transition-colors flex items-center gap-1.5 cursor-pointer"
        >
          <CalendarPlus className="w-4 h-4" />
          <span className="hidden sm:inline">Add Range</span>
        </button>
        <button
          onClick={onToday}
          className="px-3 py-1.5 [font-size:var(--fs-l4)] font-medium text-(--neutral-black-NB900) hover:bg-(--neutral-black-NB100) rounded-full! transition-colors cursor-pointer"
        >
          Today
        </button>

        <div className="flex gap-1">
          <NavigationButton onClick={onPreviousWeek} icon={ChevronLeft} ariaLabel="Previous week" />
          <NavigationButton onClick={onNextWeek} icon={ChevronRight} ariaLabel="Next week" />
        </div>
      </div>
    </div>
  );
};
